import { Component, Input, HostBinding } from '@angular/core';
import { StorageService } from '../storage-service/storage.service';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { INode } from './INode';
import { LoggerService } from '../logger-service/logger.service';
import { ConfigSearchService } from '../config-breadcrumb/config-search/config-search.service';

@Component({
    selector: 'wbm-config-master',
    templateUrl: './config-master.component.html',
})
export class ConfigMasterComponent {
    @HostBinding() class = 'flex-container-v nowrap flex-item-fluid config-tree bfc';
    @Input() public rootNode1: INode;
    @Input()
    @HostBinding('style.width') width: string = '';

    constructor(public _storage: StorageService, private _logger: LoggerService, public _oxeModel: OxeModelService, private _searchService: ConfigSearchService) {}

    public nodeSelected(node: INode) {
        this._logger.debug('ConfigMasterComponent', 'Node selected ' + node.name);
        this._searchService.showSearch = false;
        this._oxeModel.retrieveData(node)
            .subscribe(() => this._oxeModel.selectNode(node));
        this._oxeModel.helpNode(node);
    }
}
